<template>
<div class="chapter">
<div class="inner_page">
<div class="centre"><img alt="cover" height="98%" src="images/title.jpg"/></div>
<div style="page-break-before:always">
<p class="center"> </p>
<p class="center" style=" margin-bottom:0.5em"><span class="Baskerville-Italic" style=" font-size:140%">No halos, no wings.</span></p>
<p class="center"><span class="char-style-override-10">Dedicated to all those everywhere</span></p>
<p class="center"><span class="char-style-override-10">who spread kindness </span></p>
<p class="center"><span class="char-style-override-10">every day.</span><span class="char-style-override-10"></span></p>
<p class="center"> </p>
<p class="center"> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?7117bfed